import React from 'react'

import { format, parseISO } from 'date-fns'
import pt from 'date-fns/locale/pt-BR'
import { Link } from 'gatsby'
import articlesJSON from 'src/assets/data/articles.json'
import PublishedAndReadingTime from 'src/components/PublishedAndReadingTime'
import useDataLayer from 'src/hooks/useDataLayer/dataLayerBody'
import useWidth from 'src/hooks/useWidth'
import { useTheme } from 'styled-components'

import OrangeIcon from '../Icon/OrangeDsIcon'
import { ColumnistsWrapper } from './style'

type ArticleItem = {
  id: string
  authorId?: string | number
  publishedAt: string
  readingTime: number
  title: string
}

type ColumnistProps = {
  data: {
    id: string
    slug: string
    name: string
    office: string
    investorCertificate?: string | null
    image: {
      title?: string
      url: string
      alt?: string
    }
    description: string
    preSlug?: string | null
  }
  preSlug?: string | null
  articleId?: string | null
  componentStyle: {
    type?: 'articleHeader' | 'articleFooter' | 'culumnList' | 'lg' | 'sm'
  }
}

const Columnists = ({ data, articleId, componentStyle }: ColumnistProps) => {
  const theme = useTheme()
  const [sendDatalayerEvent] = useDataLayer()
  const columnistData = data
  const articles = (Object.values(articlesJSON) as ArticleItem[][]).reduce(
    (all, item) => [...all, ...item],
    [] as ArticleItem[],
  )
  const articlesFiltred = articles.filter((item: ArticleItem) => {
    if (data && data.id) {
      return item.authorId === data.id
    }
    return item.authorId && columnistData && item.authorId.toString() === columnistData.id
  })

  const article = articlesFiltred.find((item: ArticleItem) => item.id === articleId)

  const width = useWidth()
  const linkTo = (() => {
    if (data && data.preSlug && columnistData) {
      return data.preSlug + columnistData.slug
    }
    if (columnistData) {
      return columnistData.slug
    }
    return ''
  })()

  function verifyPublishedAndreadingTime() {
    return (
      (width >= 768 || componentStyle.type === 'articleHeader') &&
      componentStyle.type !== 'articleFooter'
    )
  }
  function verifyColumnistArticleTitle() {
    return componentStyle.type !== 'articleHeader' && componentStyle.type !== 'articleFooter'
  }
  function getImageSize() {
    let size = 'sm'
    if (!componentStyle.type || width > 768) {
      size = 'lg'
    }
    return size
  }

  return (
    <>
      {articlesFiltred.length > 0 && (
        <ColumnistsWrapper>
          <div className="d-flex align-items-center">
            {!componentStyle.type ||
              (componentStyle.type === 'articleFooter' && (
                <div className="mr-4 container-image">
                  {columnistData && columnistData.image && columnistData.image.url && (
                    <img
                      loading="lazy"
                      className="footer"
                      src={columnistData && columnistData.image.url}
                      alt={columnistData.image.alt || columnistData.image.title}
                    />
                  )}
                </div>
              ))}
            {!componentStyle.type ||
              (componentStyle.type === 'culumnList' && (
                <div className="mr-4 container-image">
                  {columnistData && columnistData.image && columnistData.image.url && (
                    <img
                      loading="lazy"
                      className="culumnList"
                      src={columnistData && columnistData.image.url}
                      alt={(columnistData && columnistData.image.alt) || columnistData.image.title}
                    />
                  )}
                </div>
              ))}
            {!componentStyle.type ||
              (componentStyle.type !== 'culumnList' && componentStyle.type !== 'articleFooter' && (
                <div className="mr-4 container-image">
                  {columnistData && columnistData.image && columnistData.image.url && (
                    <img
                      loading="lazy"
                      className={getImageSize()}
                      src={columnistData && columnistData.image.url}
                      alt={(columnistData && columnistData.image.alt) || columnistData.image.title}
                    />
                  )}
                </div>
              ))}
            <div className="container-text">
              {!componentStyle.type ||
                (componentStyle.type === 'articleFooter' && (
                  <>
                    <Link
                      to={`/de-investidor-para-investidor/${linkTo}`}
                      className="d-block mb-2"
                      onClick={() => {
                        sendDatalayerEvent({
                          section: '',
                          element_action: 'click button',
                          element_name: '',
                          redirect_url: `${process.env.BASE_URL}/de-investidor-para-investidor/${linkTo}`,
                        })
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <p
                          className="columnist-name sora fs-12 lh-15 fs-md-16 lh-md-20 mb-0"
                          dangerouslySetInnerHTML={{ __html: columnistData && columnistData.name }}
                        />
                        <OrangeIcon
                          color={theme.colors.primary}
                          icon="chevron-right"
                          size={width > 768 ? 'MD' : 'SM'}
                        />
                      </div>
                    </Link>
                    {columnistData && columnistData.investorCertificate && (
                      <p className="fs-14 lh-17 text-grayscale--500 mb-0">
                        {columnistData && columnistData?.investorCertificate}, {data.office}
                      </p>
                    )}
                  </>
                ))}
              {!componentStyle.type ||
                (componentStyle.type === 'culumnList' && (
                  <Link
                    to={linkTo}
                    className="d-block mb-2"
                    onClick={() => {
                      sendDatalayerEvent({
                        section: '',
                        element_action: 'click button',
                        element_name: '',
                        redirect_url: linkTo,
                      })
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <p
                        className="columnist-name sora fs-12 lh-15 fs-md-16 lh-md-20 mb-0"
                        dangerouslySetInnerHTML={{ __html: columnistData && columnistData.name }}
                      />
                      {columnistData && columnistData.investorCertificate && (
                        <span className="columnist-name sora fs-12 lh-15 fs-md-16 lh-md-20 mb-0">
                          , {columnistData && columnistData?.investorCertificate}
                        </span>
                      )}
                      <OrangeIcon
                        color={theme.colors.primary}
                        icon="chevron-right"
                        size={width > 768 ? 'MD' : 'SM'}
                      />
                    </div>
                  </Link>
                ))}
              {!componentStyle.type ||
                (componentStyle.type === 'articleHeader' && (
                  <Link
                    to={`/de-investidor-para-investidor/${linkTo}`}
                    className="d-block mb-2"
                    onClick={() => {
                      sendDatalayerEvent({
                        section: '',
                        element_action: 'click button',
                        element_name: '',
                        redirect_url: `${process.env.BASE_URL}/de-investidor-para-investidor/${linkTo}`,
                      })
                    }}
                  >
                    <p
                      className="text-grayscale--500 sora fw-700 fs-12 lh-15 fs-md-14 lh-md-20 mr-3 mb-2"
                      dangerouslySetInnerHTML={{ __html: columnistData && columnistData.name }}
                    />
                  </Link>
                ))}
              {articlesFiltred.length > 0 && verifyPublishedAndreadingTime() && (
                <PublishedAndReadingTime
                  dataPublicacao={format(
                    parseISO(
                      articleId && article ? article.publishedAt : articlesFiltred[0].publishedAt,
                    ),
                    'dd/LLL',
                    {
                      locale: pt,
                    },
                  )}
                  tempoLeitura={
                    articleId && article
                      ? article.readingTime.toString()
                      : articlesFiltred[0].readingTime.toString()
                  }
                />
              )}
              {articlesFiltred.length > 0 && verifyColumnistArticleTitle() && (
                <p
                  className="fs-12 lh-15 fs-md-20 lh-md-25 fw-700 mt-0 mt-md-3 mt-lg-4"
                  dangerouslySetInnerHTML={{
                    __html: articleId && article ? article.title : articlesFiltred[0].title,
                  }}
                />
              )}
            </div>
          </div>
        </ColumnistsWrapper>
      )}
    </>
  )
}
export default Columnists
